import { RouterProvider, createHashRouter } from "react-router-dom";

import NamekRouter from "./router/Namek.router";
import { NamekAuthRoot } from "./features/auth";
import { CenterLayout } from "./components/layouts/CenterLayout/CenterLayout";
import { ResultBlocker } from "./components/organisms/Result";

export function App() {
  const hashRoute = createHashRouter([
    {
      path: "*",
      Component: NamekAuthRoot,
      children: [{ path: "*", Component: NamekRouter }],
      errorElement: (
        <CenterLayout>
          <ResultBlocker status="internalError" />
        </CenterLayout>
      ),
    },
  ]);

  return <RouterProvider router={hashRoute} />;
}
